export default __webpack_public_path__ + "static/media/1059.d925f00b.png";